import {Component, inject, OnInit, ViewChild} from '@angular/core';
import {PermissionTypes} from "../../enum/PermissionTypes";
import {NewGameService} from "../../services/new-game.service";
import {MatStepper} from "@angular/material/stepper";
import {IGameQueryResult} from "../../interfaces/IGameQueryResult";
import {GameService} from "../../services/game.service";
import {GameStateEnum} from "../../enum/GameStateEnum";
import {MatListOption, MatSelectionList} from "@angular/material/list";
import {MatButton} from "@angular/material/button";
import {InitGameComponent} from "../../components/new-game/init-game/init-game.component";
import {NewGameContainerComponent} from "../../components/new-game/new-game-container/new-game-container.component";
import {CharityService} from "../../services/charity.service";
import {ContainerComponent} from "@coreui/angular";

@Component({
  selector: 'app-new-game',
  templateUrl: './new-game.component.html',
  standalone: true,
  imports: [
    MatSelectionList,
    MatListOption,
    MatButton,
    InitGameComponent,
    NewGameContainerComponent,
    ContainerComponent
  ],
  styleUrl: './new-game.component.scss'
})
export class NewGameComponent implements OnInit {
  @ViewChild('stepper')
  public stepper!: MatStepper;

  private newGameService: NewGameService = inject(NewGameService);
  private gameService: GameService = inject(GameService);
  private charityService: CharityService = inject(CharityService);

  public loadInProgressGame: boolean = false;
  public startNewGame: boolean = false;
  public availableDraftGames: IGameQueryResult[] = this.gameService.getAllAvailableGames().filter((game) => game.State == GameStateEnum.Draft);
  public showDraftGames = false;
  public newGameId: string = '';

  protected readonly permissionTypes = PermissionTypes;

  ngOnInit(): void {
    this.gameService.clearActiveGame();
    this.charityService.clearCharityStore();
    const areDraftGames = this.availableDraftGames.length > 0;

    if (!areDraftGames) {
      this.startNewGame = true;
    } else {
      this.showDraftGames = true;
    }
  }

  public newGameInitiated() {
    const recentlyCreatedStoredGameId = this.newGameService.newGameId();
    if (recentlyCreatedStoredGameId) {
      this.newGameId = recentlyCreatedStoredGameId;
      this.startNewGame = false;
      this.showDraftGames = false;
      this.loadInProgressGame = true;
    }
  }

  public continueWithDraftGame(gameP: IGameQueryResult) {
    this.newGameId = gameP.Id;
    this.newGameService.clearGameInProgress();
    this.newGameService.mapToCompleteNewGameRequest(gameP);
    this.loadInProgressGame = true;
  }

  public shouldStartNewGame() {
    this.newGameService.clearGameInProgress();
    this.startNewGame = true;
  }
}
